import { ColorValueStrict } from 'fronton-react';
import { StepStructure } from 'common/components';

export const CONSTRUCTION_HOUSES_PATH = '/uslugi/gotovye-resheniya-pod-klyuch/stroitelstvo-domov/';

export const CONSTRUCTION_HOUSES_ELEMENT_BLOCK = 'counstructionHouses';

export const CONSTRUCTION_HOUSES_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/construction-houses';

export const CONSTRUCTION_HOUSES_LANDING_NAME = 'construction-houses';

export const CONSTRUCTION_HOUSES_PARTNER_BANNER = {
  bgColor: '#21282B',
  elementBlock: CONSTRUCTION_HOUSES_ELEMENT_BLOCK,
  content: {
    media: {
      alt: 'Нашим партнёрам',
      srcD: `${CONSTRUCTION_HOUSES_CDN_PATH}/banners/banner-partner-d.png/banner-partner-d.png`,
      srcT: `${CONSTRUCTION_HOUSES_CDN_PATH}/banners/banner-partner-t.png/banner-partner-t.png`,
      src: `${CONSTRUCTION_HOUSES_CDN_PATH}/banners/banner-partner-m.png/banner-partner-m.png`,
    },
    title: 'Станьте нашим партнёром',
    text: 'Специальные условия для профессионалов',
  },
  link: {
    href: '/postavshchikam/uslugi/',
    title: 'Развивайте бизнес вместе с Лемана ПРО',
  },
  promotion: {
    name: 'promoSectionTop',
    creative: 'Станьте нашим партнёром',
    position: '1',
  },
};

export const CONSTRUCTION_HOUSES_CARDS_BANNER = {
  bgColor: '#A0B9B1',
  elementBlock: CONSTRUCTION_HOUSES_ELEMENT_BLOCK,
  content: {
    media: {
      alt: 'Наши карты',
      srcD: `${CONSTRUCTION_HOUSES_CDN_PATH}/banners/banner-cards-d.png/banner-cards-d.png`,
      srcT: `${CONSTRUCTION_HOUSES_CDN_PATH}/banners/banner-cards-t.png/banner-cards-t.png`,
      src: `${CONSTRUCTION_HOUSES_CDN_PATH}/banners/banner-cards-m.png/banner-cards-m.png`,
    },
    title: 'С\u00A0нашими картами ещё выгоднее!',
    text: 'Выбери свою',
    textColor: 'text-primary' as ColorValueStrict,
  },
  link: {
    href: '/programmy-loyalnosti/',
    title: 'Откройте выгоду: выберите свою Ключ-карту',
  },
  promotion: {
    name: 'promoSectioMiddle',
    creative: 'С нашими картами ещё выгоднее!',
    position: '1',
  },
};

export const CONSTRUCTION_HOUSES_STEPS_LIST: StepStructure[] = [
  {
    title: 'Перейдите на\u00A0страницу проекта',
    description:
      'Узнайте подробнее об\u00A0этапе строительства и\u00A0заполните форму для записи на\u00A0консультацию.',
  },
  {
    title: 'Отправьте заявку',
    description: 'Мы\u00A0перезвоним, проконсультируем и\u00A0договоримся о\u00A0выезде специалиста.',
  },
  {
    title: 'Закажите замер',
    description:
      'Специалист приедет по\u00A0вашему адресу, составит обмерный план и\u00A0определит объём работ.',
  },
  {
    title: 'Согласуйте смету и\u00A0договор',
    description:
      'Мы\u00A0подготовим расчёты и\u00A0проект, составим смету и\u00A0оформим договор\u00A0\u2014 это\u00A0бесплатно.',
  },
  {
    title: 'Примите материалы и\u00A0дождитесь мастера',
    description:
      'Мы\u00A0доставим заказ, или вы\u00A0можете забрать его сами, а\u00A0опытные специалисты выполнят услугу на\u00A0вашем участке.',
  },
];
